
import React from 'react'
import { Check } from "@mui/icons-material"

import "./customicons.css"

export const CheckIconMedium = ({ disabled, onClick }) => {

  return (
   
    <div>
      <Check className= "iconCheckMedium" onClick = {onClick}/>
    </div> 

  )
}
  




